<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure">
<div class="epigraph">
<p class="eps"><a class="page" id="pv"></a>It is certainly not an overstatement to say that no one has ever spoken so greatly and so nobly of what a philosopher is as Nietzsche.</p>
<p class="ept">Leo Strauss</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lampert-0005.vue?51015bb4